import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Box,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import { Button, DateRangePicker, Toolbar } from "common";
import ProgramCheckboxSelector from "components/ProgramCheckboxSelector/ProgramCheckboxSelector";
import { useAdvancedReportContext } from "features/reports/AdvancedReport/useAdvancedReport";
import useSettings from "features/settings/useSettings";
import { useEffect } from "react";

export default function CoordinatorReport3Filter() {
  const { filter, setFilter, params, setParams } = useAdvancedReportContext();
  const [settings, setSettings] = useSettings({ key: "advancedReport" });

  useEffect(() => {
    if (params.dateType !== "booking" || params.groupBy !== "partner") {
      setParams({
        ...params,
        dateType: "booking",
        groupBy: "partner",
      });
    }
  }, [params.dateType, params.groupBy]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Paper
        sx={{
          p: 1,
          display: "flex",
          alignItems: "center",
          flex: 1,
          alignSelf: "stretch",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            p: 1,
            display: "flex",
            alignItems: "center",
            flex: 1,
            alignSelf: "stretch",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            flexDirection: "column",
          }}
        >
          <DateRangePicker
            sx={{ width: 200 }}
            defaultRangeIdStorageKey="coordinatorReport3DateRange"
            value={{ from: filter.from, to: filter.to }}
            onChange={range => {
              setFilter({
                ...filter,
                ...(range as any),
              });
            }}
          />

          <Toolbar sx={{ alignSelf: "stretch", gap: 2, flexWrap: "wrap" }}>
            <FormControl sx={{ flex: 1, minWidth: 200 }}>
              <InputLabel>Érték</InputLabel>
              <Select
                value={params.value}
                label="Érték"
                onChange={e =>
                  setParams({
                    ...params,
                    value: e.target.value as any,
                  })
                }
              >
                <MenuItem value="count">Foglalások száma</MenuItem>
                <MenuItem value="guests">Létszám</MenuItem>
              </Select>
            </FormControl>
          </Toolbar>
        </Box>

        <Button
          variant="text"
          size="small"
          endIcon={settings.show_filter ? <ExpandLess /> : <ExpandMore />}
          title={settings.show_filter ? "Szűrő elrejtése" : "Szűrő mutatása"}
          onClick={() => {
            setSettings({ show_filter: !settings.show_filter });
          }}
        />

        <Collapse in={settings.show_filter} sx={{ maxWidth: "100%" }}>
          <Box
            sx={{
              p: 1,
              flex: 1,
              alignSelf: "stretch",
              pl: 3,
            }}
          >
            <ProgramCheckboxSelector
              value={filter.programIds || []}
              onChange={evt =>
                setFilter({
                  ...filter,
                  programIds: (evt.target?.value
                    ? evt.target?.value
                    : []) as any,
                })
              }
              showMore={settings.show_all_programs}
              setShowMore={show_all =>
                setSettings({ show_all_programs: show_all })
              }
            />
          </Box>
        </Collapse>
      </Paper>
    </Box>
  );
}
